import { BootstrapRouter } from './bootstrap.router';

export const Bootstrap = () => {
    return <BootstrapRouter />;
};
